import { DataTableFilterBarV2Component } from './index';
import { dataTableFilterBarTemplate } from '../../DataTable/DataTableFilterBar//DataTableFilterBar';
import styles from '../../DataTable/DataTableFilterBar//DataTableFilterBar.styles.scss';
export const chameleonDataTableFilterBarV2 = DataTableFilterBarV2Component.compose({
    baseName: 'data-table-filter-bar-v2',
    template: dataTableFilterBarTemplate,
    styles,
});
